import { Component, ChangeDetectionStrategy, signal } from '@angular/core';

import { PhosphorIconComponent } from '@cintra-payroll-hr/components';
import { ResponsiveWorkareaComponent } from '../responsive-workarea.component';

@Component({
  selector: 'app-container-query-test',
  standalone: true,
  imports: [ResponsiveWorkareaComponent, PhosphorIconComponent],
  templateUrl: './container-query-test.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContainerQueryTestComponent {
  useCustomHeader = signal(false);
  showTabs = signal(true);

  toggleHeaderMode() {
    this.useCustomHeader.update((current) => !current);
  }

  toggleTabs() {
    this.showTabs.update((current) => !current);
  }

  cards = [
    {
      content:
        'This card demonstrates responsive layout using container queries. The layout responds to the content area width rather than viewport width.',
      category: 'Demo',
      updated: '2 mins ago'
    },
    {
      content: 'When the sidebar expands or collapses, these cards will reflow based on the available content space.',
      category: 'Feature',
      updated: '5 mins ago'
    },
    {
      content:
        'Traditional Bootstrap responsive classes respond to viewport width. These container query classes respond to content area width.',
      category: 'Technical',
      updated: '10 mins ago'
    },
    {
      content: 'This enables true content-area responsive design in dynamic layouts with collapsible sidebars.',
      category: 'Benefit',
      updated: '15 mins ago'
    },
    {
      content: 'Cards will stack 1 column (xs), 2 columns (sm-md), or 3 columns (lg+) based on content area breakpoints.',
      category: 'Layout',
      updated: '20 mins ago'
    },
    {
      content: 'The responsive behavior is powered by CSS Container Queries with Bootstrap-style class names.',
      category: 'Technology',
      updated: '25 mins ago'
    }
  ];
}
